// import { useEffect, useRef, useState } from "react";
// import { NavLink } from "react-router-dom";
// import SimpleBar from "simplebar-react";
// import "simplebar-react/dist/simplebar.min.css";
// import { FiHome, FiGrid, FiFolder, FiChevronDown } from "react-icons/fi";
// import { motion } from "framer-motion";
// import { useSidebar } from "units/dashboard/context/SidebarProvider";

// const AdminSidebar = () => {
//   const [openMenu, setOpenMenu] = useState(null);
//   const { isSidebarOpen, toggleSidebar } = useSidebar();
//   const sidebarRef = useRef(null)
//   const toggleMenu = (menuKey) => {
//     setOpenMenu(openMenu === menuKey ? null : menuKey);
//   };

//   return (
//     <SimpleBar data-simplebar className={`h-full  ${isSidebarOpen ? 'open' : 'closed'}`} ref={sidebarRef}>
//       <div id="sidebar-menu">
//         <ul className="metismenu" id="side-menu">
//           <li className="menu-heading px-4 py-3.5 text-xs font-medium text-gray-500 cursor-default">
//             منو
//           </li>

//           {/* داشبورد */}
//           <li>
//             <NavLink
//               to="/admin/dashboard"
//               className={({ isActive }) =>
//                 `flex items-center pl-6 pr-4 py-3 text-sm font-medium transition-all duration-150 ease-linear 
//                 ${isActive ? "text-violet-500 font-bold" : "text-gray-700 hover:text-violet-500"}`
//               }
//             >
//               <FiHome className="mr-2 text-lg" />
//               <span data-key="t-dashboard"> داشبورد</span>
//             </NavLink>
//           </li>

//           {/* مدیریت گفتگوها */}
//           <li>
//             <a
//               onClick={() => toggleMenu("chats")}
//               className="w-full flex items-center justify-between pl-6 pr-4 py-3 text-sm font-medium text-gray-700 hover:text-violet-500 dark:text-gray-300 dark:hover:text-white"
//             >
//               <FiGrid className="mr-2 text-lg" />
//               <span data-key="t-apps" className="w-full">مدیریت گفتگوها
//                 <FiChevronDown className={`mr-[3.6rem] transform transition-transform ${openMenu === "chats" ? "rotate-180" : "rotate-0"}`} />
//               </span>

//             </a>
//             <motion.ul
//               initial={{ height: 0, opacity: 0 }}
//               animate={{ height: openMenu === "chats" ? "auto" : 0, opacity: openMenu === "chats" ? 1 : 0 }}
//               transition={{ duration: 0.3 }}
//               className="overflow-hidden"
//             >
//               <li>
//                 <NavLink
//                   to="/admin/chats"
//                   className={({ isActive }) =>
//                     `block pr-14 pl-4 py-2 text-[13.5px] font-medium transition-all duration-150 ease-linear 
//                     ${isActive ? "text-violet-500 font-bold" : "text-gray-700 hover:text-violet-500"}`
//                   }
//                 >
//                   لیست گفتگوها
//                 </NavLink>
//               </li>
//             </motion.ul>
//           </li>

//           {/* لیست بات‌ها */}
//           <li>
//             <NavLink
//               to="/admin/publish"
//               className={({ isActive }) =>
//                 `flex items-center pl-6 pr-4 py-3 text-sm font-medium transition-all duration-150 ease-linear 
//                 ${isActive ? "text-violet-500 font-bold" : "text-gray-700 hover:text-violet-500"}`
//               }
//             >
//               <FiFolder className="mr-2 text-lg" />
//               <span data-key="t-dashboard"> لیست بات های درخواستی </span>
//             </NavLink>
//           </li>
//         </ul>
//       </div>
//     </SimpleBar>
//   );
// };

// export default AdminSidebar;
// import React from 'react'
// import { PulseLoader } from 'react-spinners';
// import ClipLoader from "react-spinners/ClipLoader";
// export default function Test() {
//   return (
//    <div className='bg-black'>
//     {/* <div class="flex justify-center items-center space-x-2">
//   <div class="w-5 h-5 border-t-4 border-blue-500 border-solid rounded-full animate-spin"></div>
// </div>
// <div class="flex justify-center items-center space-x-2">
//   <div class="w-16 h-16 border-4 border-t-4 border-blue-500 border-solid rounded-full animate-spin"></div>
// </div> */}
// <PulseLoader
//   color="#f2f1f1"
//   size={9}
// />
//    </div>
//   )
// }
// const StatsSection = () => {
//   return (
//     <section className="bg-gray-900 text-white py-16 px-6 text-center">
//     {/* <h2 className="text-3xl md:text-4xl font-bold mb-4">
//       Trusted by creators worldwide
//     </h2>
//     <p className="text-gray-400 mb-10 mx-auto">
//       Lorem ipsum dolor sit amet consect adipisicing possimus.
//     </p> */}
//     <div className="mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 w-full px-6">
//       <div className="bg-gray-800 py-6 px-4 rounded-lg">
//         <p className="text-2xl font-bold">8,000+</p>
//         <p className="text-gray-400 text-sm">Creators on the platform</p>
//       </div>
//       <div className="bg-gray-800 py-6 px-4 rounded-lg">
//         <p className="text-2xl font-bold">3%</p>
//         <p className="text-gray-400 text-sm">Flat platform fee</p>
//       </div>
//       <div className="bg-gray-800 py-6 px-4 rounded-lg">
//         <p className="text-2xl font-bold">99.9%</p>
//         <p className="text-gray-400 text-sm">Uptime guarantee</p>
//       </div>
//       <div className="bg-gray-800 py-6 px-4 rounded-lg">
//         <p className="text-2xl font-bold">$70M</p>
//         <p className="text-gray-400 text-sm">Paid out to creators</p>
//       </div>
//     </div>
//   </section>
//   );
// };

// export default StatsSection;
// const links = [
//   { name: 'Open roles', href: '#' },
//   { name: 'Internship program', href: '#' },
//   { name: 'Our values', href: '#' },
//   { name: 'Meet our leadership', href: '#' },
// ]
// const stats = [
//   { name: 'Offices worldwide', value: '12' },
//   { name: 'Full-time colleagues', value: '300+' },
//   { name: 'Hours per week', value: '40' },
//   { name: 'Paid time off', value: 'Unlimited' },
// ]

// export default function Example() {
//   return (
//     <div className="relative isolate overflow-hidden bg-gray-900 py-24 sm:py-32">
//       <img
//         alt=""
//         src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&crop=focalpoint&fp-y=.8&w=2830&h=1500&q=80&blend=111827&sat=-100&exp=15&blend-mode=multiply"
//         className="absolute inset-0 -z-10 size-full object-cover object-right md:object-center"
//       />
//       <div
//         aria-hidden="true"
//         className="hidden sm:absolute sm:-top-10 sm:right-1/2 sm:-z-10 sm:mr-10 sm:block sm:transform-gpu sm:blur-3xl"
//       >
//         <div
//           style={{
//             clipPath:
//               'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
//           }}
//           className="aspect-1097/845 w-[68.5625rem] bg-linear-to-tr from-[#ff4694] to-[#776fff] opacity-20"
//         />
//       </div>
//       <div
//         aria-hidden="true"
//         className="absolute -top-52 left-1/2 -z-10 -translate-x-1/2 transform-gpu blur-3xl sm:top-[-28rem] sm:ml-16 sm:translate-x-0 sm:transform-gpu"
//       >
//         <div
//           style={{
//             clipPath:
//               'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
//           }}
//           className="aspect-1097/845 w-[68.5625rem] bg-linear-to-tr from-[#ff4694] to-[#776fff] opacity-20"
//         />
//       </div>
//       <div className="mx-auto max-w-7xl px-6 lg:px-8">
//         <div className="mx-auto max-w-2xl lg:mx-0">
//           <h2 className="text-5xl font-semibold tracking-tight text-white sm:text-7xl">Work with us</h2>
//           <p className="mt-8 text-lg font-medium text-pretty text-gray-300 sm:text-xl/8">
//             Anim aute id magna aliqua ad ad non deserunt sunt. Qui irure qui lorem cupidatat commodo. Elit sunt amet
//             fugiat veniam occaecat fugiat.
//           </p>
//         </div>
//         <div className="mx-auto mt-10 max-w-2xl lg:mx-0 lg:max-w-none">
//           <div className="grid grid-cols-1 gap-x-8 gap-y-6 text-base/7 font-semibold text-white sm:grid-cols-2 md:flex lg:gap-x-10">
//             {links.map((link) => (
//               <a key={link.name} href={link.href}>
//                 {link.name} <span aria-hidden="true">&rarr;</span>
//               </a>
//             ))}
//           </div>
//           <dl className="mt-16 grid grid-cols-1 gap-8 sm:mt-20 sm:grid-cols-2 lg:grid-cols-4">
//             {stats.map((stat) => (
//               <div key={stat.name} className="flex flex-col-reverse gap-1">
//                 <dt className="text-base/7 text-gray-300">{stat.name}</dt>
//                 <dd className="text-4xl font-semibold tracking-tight text-white">{stat.value}</dd>
//               </div>
//             ))}
//           </dl>
//         </div>
//       </div>
//     </div>
//   )
// }

import React from "react";
import MarkdownIt from "markdown-it";
import DOMPurify from "dompurify";

// نمونه markdown-it با پیکربندی پیشرفته
const md = new MarkdownIt({
  html: true, // پشتیبانی از HTML داخل Markdown
  linkify: true, // تشخیص خودکار لینک‌ها
  typographer: true, // بهینه‌سازی تایپوگرافی
});

// تابع تبدیل Markdown به HTML ایمن
export function convertMarkdownToSafeHtml(markdownText) {
  const rawHtml = md.render(markdownText);
  return DOMPurify.sanitize(rawHtml);
}

const MarkdownDisplay = ({ markdownText }) => {
  const safeHtmlContent = convertMarkdownToSafeHtml(markdownText);

  return (
    <div
      className="prose max-w-none"
      dangerouslySetInnerHTML={{ __html: safeHtmlContent }}
    />
  );
};

// 📌 تست با یک متن Markdown کامل
const testMarkdown = `
# عنوان H1
## عنوان H2
### عنوان H3
**متن بولد** و *ایتالیک* و ~~خط خورده~~  
> این یک نقل قول است.

\`\`\`js
console.log("کد جاوااسکریپت");
\`\`\`

1. لیست شماره‌دار
2. مورد دوم

- لیست بدون شماره
- مورد دیگر

[لینک نمونه](https://example.com)

![عکس تستی](https://via.placeholder.com/150)

---

<span style="color:red">متن قرمز</span>
`;

export default function App() {
  return (
    <div className="p-6">
      <MarkdownDisplay markdownText={testMarkdown} />
    </div>
  );
}
